export const waitForElm = selector => {
  return new Promise(resolve => {
    if (document.getElementById(selector)) {
      return resolve(document.getElementById(selector))
    }

    const observer = new MutationObserver(mutations => {
      if (document.getElementById(selector)) {
        resolve(document.getElementById(selector))
        observer.disconnect()
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

export const waitForElementForPeriod = (selector: string, seconds: number) => {
  return new Promise((resolve, reject) => {
    if (document.getElementById(selector)) {
      return resolve(document.getElementById(selector))
    }

    const timerId = setTimeout(() => {
      observer.disconnect()
      reject("Element Not found - Time exceed")
    }, seconds)

    const observer = new MutationObserver(mutations => {
      if (document.getElementById(selector)) {
        clearTimeout(timerId)
        resolve(document.getElementById(selector))
        observer.disconnect()
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}
